import {
  VerificationCriteriaTaskActionStatus,
  VerificationCriteriaTaskCompletionStatus,
  VerificationCriteriaTaskParams,
} from '@/backend/access/verificationCriteriaTask/types';

export class VerificationCriteriaTask {
  id: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  description: string;
  verificationCriteriaId: string;
  actionStatus: VerificationCriteriaTaskActionStatus;
  completionStatus: VerificationCriteriaTaskCompletionStatus;
  propelOrgId: string;
  assignedUserId: string | null;

  constructor(params: VerificationCriteriaTaskParams) {
    this.id = params.id;
    this.createdAt = params.createdAt;
    this.updatedAt = params.updatedAt;
    this.description = params.description ?? '';
    this.verificationCriteriaId = params.verificationCriteriaId;
    this.actionStatus = params.actionStatus;
    this.completionStatus = params.completionStatus;
    this.propelOrgId = params.propelOrgId;
    this.assignedUserId = params.assignedUserId ?? null;
  }
}
